import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import Helmet from 'wanderu-component-helmet';
import { localize, selectLocale} from 'wanderu-i18n';

import cgConfig from '../../../../config/carrierguide.locale';

function CarrierGuideMeta(props) {
    const {
        i18nMoney,
        locale,
        minPriceUsd,
        noIndexLocale,
        noIndex,
        t,
        ...otherProp
    } = props;

    const description = t('metaPageDescription', {
        minPrice: i18nMoney(minPriceUsd).format(),
    });

    const title = t('metaPageTitle');

    const supportedLocales = () => {
        return cgConfig.supportedLocales
            .filter((locale) => !noIndexLocale?.includes(locale) ?? false);
    };

    const isNoIndex = () => {
        const isIndexable = !noIndex && (!noIndexLocale?.includes(locale) ?? true);
        return !isIndexable;
    };

    return (
        <Helmet
            {...otherProp}
            description={description}
            noIndex={isNoIndex()}
            supportedLocales={supportedLocales()}
            title={title}
        />
    );
}

CarrierGuideMeta.propTypes = {
    locale: PropTypes.string.isRequired,
    minPriceUsd: PropTypes.number.isRequired,
    noIndex: PropTypes.bool,
    noIndexLocale: PropTypes.arrayOf(PropTypes.string),
    structuredData: PropTypes.arrayOf(PropTypes.object),
};
CarrierGuideMeta.defaultProps = {
    noIndex: false,
    noIndexLocale: [],
    structuredData: [],
};

function mapStateToProps(state) {
    return {
        locale: selectLocale(state),
    };
}


export {
    CarrierGuideMeta,
};

export default connect(mapStateToProps)(localize(CarrierGuideMeta, ['i18nMoney', 't'], cgConfig.namespace));
